import type { Setting } from '@/types'

import Model from './Model'

type Type = Setting

export default class SettingModel extends Model {
  static model: Type = {
    name: 'recommend',
    value: {},
  }

  static get() {
    return super.get() as Type
  }

  static prepare(model: Partial<Type>, without: (keyof Type)[]) {
    return super.prepare(model, without) as Partial<Type>
  }

  static difference(snapshot: Partial<Type>, formModel: Partial<Type>) {
    return super.difference(snapshot, formModel) as Partial<Type>
  }

  static reset(formModel: Type, snapshot?: Type) {
    return super.reset(formModel, snapshot) as Type
  }

  static mergeTogether(model: Type) {
    return super.mergeTogether(model) as Type
  }
}
